module.exports = __webpack_public_path__ + "img/diploma_5.2bad15a8.jpg";